/* Red Raven — PD Meter — build 2026-07-30c
   Client-side pupillary distance measurement. No image ever leaves the device.
   Debug: append ?pdm_debug=1 to the URL to walk every screen without a camera. */
(function () {
  'use strict';

  var CARD_W_MM = 85.6;
  var IRIS_MM = 11.7;
  /* Flat offset against optician readings, measured over four people. It lives
     here rather than in a section setting because Shopify's page cache can
     serve HTML rendered before the setting existed, and such a visitor would
     silently lose the calibration. The setting adds to this, it does not
     replace it. */
  var CALIB_MM = -1.8;
  var WORK_W = 720;
  var MIN_FRAME_MS = 42;
  var MP_CDN = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  var MP_MODEL =
    'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';

  /* ------------------------------------------------------------------ *
   * ΚΕΙΜΕΝΑ — όλα όσα βλέπει ο πελάτης είναι εδώ.                       *
   * ------------------------------------------------------------------ */
  var STR = {
    el: {
      step: 'Βήμα {n} από 3',

      introTitle: 'Πάρε μια κάρτα στο χέρι σου',
      introLead:
        'Τραπεζική, ταυτότητα ή κάρτα σούπερ μάρκετ — όλες έχουν ακριβώς το ίδιο μέγεθος, οπότε τη χρησιμοποιούμε σαν χάρακα.',
      needCard: 'Μια κάρτα σε μέγεθος τραπεζικής (όχι μπεζ/nude)',
      needLight: 'Καλό φως, χωρίς κόντρα φως',
      needPhone: 'Μπροστινή κάμερα, 40–70 εκ. μακριά',
      introMoreTitle: 'Γιατί χρειάζεται κάρτα;',
      introMore:
        'Η κάμερα δεν ξέρει πόσο μακριά είσαι, άρα δεν μπορεί μόνη της να μετρήσει σε χιλιοστά. Κάθε τραπεζική κάρτα έχει πλάτος ακριβώς 85,60 χιλιοστά διεθνώς. Δουλεύει με κάθε χρώμα κάρτας — απλώς απόφυγε μπεζ ή nude, γιατί χάνονται μέσα στο χρώμα του δέρματος.',
      introCta: 'Ξεκίνα τη μέτρηση',

      capTitle: 'Ακούμπα την κάρτα στο μέτωπό σου',
      capLead: 'Οριζόντια, ακριβώς πάνω από τα φρύδια. Κοίτα ευθεία στον φακό.',
      capCta: 'Μέτρησε',
      capHold: 'Κράτα σταθερά…',
      cFew: 'Δεν μάζεψα αρκετές καθαρές μετρήσεις. Κράτα το κινητό πιο σταθερά, με καλό φως — ή βάλε τις κουκκίδες μόνος σου.',
      capManual: 'Δεν τα καταφέρνω — βάλε τις κουκκίδες μόνος σου',
      rotate: 'Γύρνα το κινητό όρθιο για καλύτερη μέτρηση',

      loadLib: 'Ετοιμάζω το εργαλείο αναγνώρισης…',
      loadModel: 'Κατεβάζω το μοντέλο αναγνώρισης προσώπου… {p}%',
      loadDone: 'Έτοιμο!',

      verTitle: 'Έλεγξε τις κουκκίδες',
      verLead:
        'Κόκκινες ακριβώς στο κέντρο της κόρης, λευκές ακριβώς στις δύο άκρες της κάρτας. Πιάσε την καθεμία για να τη δεις μεγεθυμένη και σύρε όποια δεν είναι σωστή — και μισό χιλιοστό μετράει.',
      verOk: 'Σωστά',
      verBad: 'Λάθος',
      verCheck: 'Πιάσε μία-μία και τις 4 κουκκίδες για να τις δεις από κοντά — {n}/4',
      verCheckDone: 'Τις έλεγξες και τις 4 ✓',
      verCta: 'Οι κουκκίδες είναι σωστές ✓',
      verBack: 'Νέα φωτογραφία',
      verManual: 'Καταχωρήθηκε η διόρθωσή σου.',

      resTitle: 'Η κορική σου απόσταση',
      resMeaning: 'Αυτόν τον αριθμό δίνεις όταν παραγγέλνεις γυαλιά με βαθμούς.',
      resCopy: 'Αντιγραφή',
      resCopied: 'Αντιγράφηκε!',
      resAgain: 'Μέτρησε ξανά',
      resMono: 'Δεξί μάτι {r} mm · Αριστερό μάτι {l} mm',
      resLow: 'Η μέτρηση δεν ήταν πολύ σταθερή. Δοκίμασε ξανά με καλύτερο φως για πιο σίγουρο αποτέλεσμα.',
      resGood: 'Η μέτρηση ήταν σταθερή.',
      resDetails: 'Τεχνικές λεπτομέρειες',
      resSpread: 'Διασπορά μετρήσεων: ±{v} mm ({n} καρέ)',
      resCross: 'Έλεγχος με μέγεθος ίριδας: {v} mm',
      resCrossBad: 'Ο δεύτερος έλεγχος διαφέρει αρκετά — αν έχεις παλιά μέτρηση από οπτικό, σύγκρινέ τη.',
      resManual: 'Υπολογίστηκε από τη φωτογραφία που διόρθωσες.',
      resDist: 'Εκτιμώμενη απόσταση από την κάμερα: ~{v} εκ.',
      resGeom: 'Γεωμετρική διόρθωση: {v} mm — βάθος κάρτας {d} mm + σύγκλιση ματιών {c} mm',
      resRaw: 'Μέτρηση χωρίς διόρθωση: {v} mm',
      resCalib: 'Βαθμονόμηση: {v} mm (σταθερή, από συγκρίσεις με κορόμετρο οπτικού)',
      resShift: 'Μετακίνησες κουκκίδα κατά {v} mm — ο υπολογισμός έγινε με τις δικές σου θέσεις.',

      cNoFace: 'Δεν βλέπω το πρόσωπό σου — μπες μέσα στο πλαίσιο',
      cDark: 'Λίγο σκοτεινά — χρειάζεσαι περισσότερο φως',
      cBright: 'Πολύ δυνατό φως πίσω σου — γύρνα προς το φως',
      cRoll: 'Ίσιωσε το κεφάλι σου',
      cYaw: 'Κοίτα ευθεία στην κάμερα',
      cGaze: 'Κοίτα τον φακό, όχι την εικόνα σου',
      cCard: 'Δεν βρίσκω την κάρτα — ακούμπα τη οριζόντια στο μέτωπο',
      cCardColor: 'Δεν ξεχωρίζει η κάρτα από το δέρμα σου — δοκίμασε μια πιο έντονου χρώματος κάρτα (σκούρα, μπλε, κόκκινη)',
      cNear: 'Απομακρύνσου λίγο',
      cFar: 'Πλησίασε λίγο',
      cBlur: 'Κράτα το κινητό σταθερά',
      cOk: 'Τέλεια! Μην κουνηθείς',
      cReady: 'Έτοιμο — πάτα «Μέτρησε»',
      cTapReady: 'Όταν είσαι έτοιμος, πάτα «Μέτρησε»',

      eTitle: 'Κάτι δεν πήγε καλά',
      eDenied:
        'Δεν δόθηκε άδεια για την κάμερα. Σε iPhone: πάτα το «ᴀA» αριστερά στη γραμμή διεύθυνσης → «Ρυθμίσεις ιστοτόπου» → Κάμερα → «Να επιτρέπεται». Αν δεν το βρίσκεις, πήγαινε Ρυθμίσεις → Safari → Κάμερα → «Ερώτηση» και ξαναφόρτωσε τη σελίδα.',
      eNoCam: 'Δεν βρήκα κάμερα σε αυτή τη συσκευή. Δοκίμασε από κινητό.',
      eBusy: 'Η κάμερα χρησιμοποιείται από άλλη εφαρμογή. Κλείσε την (π.χ. βιντεοκλήση) και δοκίμασε ξανά.',
      eInApp:
        'Άνοιξε αυτή τη σελίδα σε Safari ή Chrome. Μέσα στο Instagram ή στο Facebook η κάμερα δεν δουλεύει. Πάτα «Αντιγραφή συνδέσμου» και επικόλλησέ τον στον browser σου.',
      eHttps: 'Η σελίδα πρέπει να ανοίξει με https:// για να λειτουργήσει η κάμερα.',
      eUnsupported: 'Ο browser σου δεν υποστηρίζει κάμερα μέσα σε σελίδα. Δοκίμασε Safari (iPhone) ή Chrome (Android).',
      eRetry: 'Δοκίμασε ξανά',
      eCopyLink: 'Αντιγραφή συνδέσμου'
    },

    en: {
      step: 'Step {n} of 3',

      introTitle: 'Grab any bank-sized card',
      introLead:
        'A bank card, ID or loyalty card — they are all exactly the same size, so we use one as a ruler.',
      needCard: 'A bank-sized card (not beige/nude)',
      needLight: 'Good light, no backlight',
      needPhone: 'Front camera, 40–70 cm away',
      introMoreTitle: 'Why a card?',
      introMore:
        'A camera does not know how far away you are, so it cannot measure millimetres on its own. Every bank card is exactly 85.60 mm wide worldwide. Any card colour works — just avoid beige or nude ones, which blend into skin.',
      introCta: 'Open the camera',

      capTitle: 'Hold the card against your forehead',
      capLead: 'Horizontally, just above your eyebrows. Look straight into the lens.',
      capCta: 'Measure',
      capHold: 'Hold still…',
      cFew: 'I could not gather enough clean readings. Hold the phone steadier in good light — or place the dots yourself.',
      capManual: 'Not working — place the dots yourself',
      rotate: 'Turn your phone upright for a better measurement',

      loadLib: 'Preparing the detector…',
      loadModel: 'Downloading the face model… {p}%',
      loadDone: 'Ready!',

      verTitle: 'Check the dots',
      verLead:
        'Red exactly on the centre of each pupil, white exactly on the two card edges. Touch each one to see it magnified and drag any that is off — half a millimetre counts.',
      verOk: 'Right',
      verBad: 'Wrong',
      verCheck: 'Touch each of the 4 dots to see it up close — {n}/4',
      verCheckDone: 'All 4 checked ✓',
      verCta: 'The dots are correct ✓',
      verBack: 'Retake photo',
      verManual: 'Your correction has been recorded.',

      resTitle: 'Your pupillary distance',
      resMeaning: 'This is the number you give when ordering prescription glasses.',
      resCopy: 'Copy',
      resCopied: 'Copied!',
      resAgain: 'Measure again',
      resMono: 'Right eye {r} mm · Left eye {l} mm',
      resLow: 'The measurement was not very stable. Try again in better light.',
      resGood: 'The measurement was stable.',
      resDetails: 'Technical details',
      resSpread: 'Spread: ±{v} mm ({n} frames)',
      resCross: 'Iris-size cross-check: {v} mm',
      resCrossBad: 'The cross-check differs noticeably — compare with an optician measurement if you have one.',
      resManual: 'Calculated from the photo you corrected.',
      resDist: 'Estimated distance from the camera: ~{v} cm',
      resGeom: 'Geometric correction: {v} mm — card depth {d} mm + eye convergence {c} mm',
      resRaw: 'Uncorrected measurement: {v} mm',
      resCalib: 'Calibration: {v} mm (flat, from optician-ruler comparisons)',
      resShift: 'You moved a dot by {v} mm — your positions were used for the calculation.',

      cNoFace: 'I cannot see your face — move into the frame',
      cDark: 'A bit dark — you need more light',
      cBright: 'Strong light behind you — turn towards the light',
      cRoll: 'Straighten your head',
      cYaw: 'Face the camera',
      cGaze: 'Look at the lens, not at your image',
      cCard: 'I cannot find the card — hold it flat on your forehead',
      cCardColor: 'The card blends into your skin — try a stronger-coloured card (dark, blue, red)',
      cNear: 'Move back a little',
      cFar: 'Come a little closer',
      cBlur: 'Hold the phone steady',
      cOk: 'Perfect! Do not move',
      cReady: 'Ready — press “Measure”',
      cTapReady: 'When you are ready, press “Measure”',

      eTitle: 'Something went wrong',
      eDenied:
        'Camera permission was not given. On iPhone: tap “ᴀA” on the left of the address bar → “Website Settings” → Camera → “Allow”, then reload.',
      eNoCam: 'No camera found on this device. Try on a phone.',
      eBusy: 'The camera is used by another app. Close it and try again.',
      eInApp: 'Open this page in Safari or Chrome. The camera does not work inside Instagram or Facebook.',
      eHttps: 'The page must be opened over https:// for the camera to work.',
      eUnsupported: 'Your browser cannot use the camera in a page. Try Safari (iPhone) or Chrome (Android).',
      eRetry: 'Try again',
      eCopyLink: 'Copy link'
    }
  };

  /* ------------------------------------------------------------------ *
   * Helpers                                                             *
   * ------------------------------------------------------------------ */
  function $(root, sel) {
    return root.querySelector(sel);
  }
  function all(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function fmt(s, vars) {
    return String(s).replace(/\{(\w+)\}/g, function (m, k) {
      return vars && vars[k] != null ? vars[k] : m;
    });
  }
  function dist(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }
  function median(arr) {
    if (!arr.length) return NaN;
    var s = arr.slice().sort(function (a, b) {
      return a - b;
    });
    var m = s.length >> 1;
    return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
  }
  function mad(arr, med) {
    if (arr.length < 2) return 0;
    return (
      1.4826 *
      median(
        arr.map(function (v) {
          return Math.abs(v - med);
        })
      )
    );
  }
  function trimmedMean(arr, frac) {
    if (!arr.length) return NaN;
    var s = arr.slice().sort(function (a, b) {
      return a - b;
    });
    var cut = Math.floor(s.length * (frac || 0.2));
    var kept = s.slice(cut, s.length - cut);
    if (!kept.length) kept = s;
    var sum = 0;
    for (var i = 0; i < kept.length; i++) sum += kept[i];
    return sum / kept.length;
  }
  /* ------------------------------------------------------------------ *
   * Γεωμετρία — από την ωμή μέτρηση στην κορική απόσταση μακρινής όρασης
   *
   * Δύο συστηματικά σφάλματα κάνουν την ωμή μέτρηση ΜΙΚΡΟΤΕΡΗ από την
   * πραγματική, και τα δύο αντιστρόφως ανάλογα της απόστασης:
   *
   *  1) Επίπεδο κάρτας. Η κάρτα ακουμπάει στο μέτωπο, δηλαδή Δ mm πιο
   *     μπροστά από τις κόρες. Έτσι φαίνεται μεγαλύτερη απ' όσο θα
   *     φαινόταν στο επίπεδο των ματιών και η κλίμακα mm/pixel βγαίνει
   *     μικρή. Σφάλμα ≈ −PD·Δ/D.
   *  2) Σύγκλιση. Ο πελάτης κοιτάει τον φακό, άρα τα μάτια στρέφονται
   *     προς τα μέσα γύρω από το κέντρο περιστροφής του βολβού, R mm
   *     πίσω από την κόρη. Ο οπτικός θέλει την απόσταση μακρινής όρασης
   *     (παράλληλοι άξονες). Σφάλμα ≈ −PD·R/D.
   *
   * Με μοντέλο pinhole, εστιακή απόσταση f pixel και κάρτα w pixel:
   *     z_card = f · 85.6 / w        (κάμερα → κάρτα)
   *     D      = z_card + Δ          (κάμερα → κόρες)
   *     PD_far = PD_raw · (D + R) / z_card
   *
   * Το f = k · (ΜΕΓΑΛΗ πλευρά του καρέ): το ονομαστικό άνοιγμα φακού
   * αντιστοιχεί στον μεγάλο άξονα του αισθητήρα. Το κινητό όρθιο δίνει
   * portrait stream (720×1280), οπότε το «πλάτος» είναι η μικρή πλευρά και
   * καλύπτει πολύ στενότερη γωνία.
   * ------------------------------------------------------------------ */
  function Geometry(fovDeg, offsetMM, rotMM) {
    fovDeg = clampNum(fovDeg, 40, 100, 73);
    this.k = 0.5 / Math.tan(((fovDeg / 2) * Math.PI) / 180);
    this.off = clampNum(offsetMM, 0, 40, 18);
    this.rot = clampNum(rotMM, 0, 20, 13.5);
  }
  /* cardPx is measured in the same pixel grid as frameW x frameH.
     The focal length is tied to the LONG side of the frame, never to its
     width: a phone held upright hands us a portrait stream (720x1280), so
     the frame width is the SHORT side and carries a far narrower angle than
     the camera's nominal horizontal field of view. Scaling by the width there
     shrinks the distance estimate by the aspect ratio and roughly doubles
     every correction that depends on it. */
  Geometry.prototype.solve = function (cardPx, frameW, frameH) {
    var longSide = Math.max(frameW || 0, frameH || 0);
    if (!(cardPx > 0) || !(longSide > 0)) return { factor: 1, dist: 0, zCard: 0 };
    var zCard = clampNum((this.k * longSide * CARD_W_MM) / cardPx, 150, 1400, 450);
    return {
      factor: Math.min(1.3, (zCard + this.off + this.rot) / zCard),
      depthShare: this.off / zCard,
      convShare: this.rot / zCard,
      dist: zCard + this.off,
      zCard: zCard
    };
  };

  function clampNum(v, lo, hi, dflt) {
    v = parseFloat(v);
    if (!isFinite(v)) return dflt;
    return Math.min(hi, Math.max(lo, v));
  }

  function isInAppBrowser() {
    var ua = navigator.userAgent || '';
    return /FBAN|FBAV|FB_IAB|Instagram|Line\/|MicroMessenger|Twitter|Pinterest|Snapchat|TikTok|LinkedInApp/i.test(ua);
  }
  function debugOn() {
    return /[?&]pdm_debug=1/.test(location.search);
  }

  /* ------------------------------------------------------------------ *
   * Gray region — a reusable sub-rectangle of the frame, so we only     *
   * read back the pixels we actually need (getImageData is the most     *
   * expensive step on mobile GPUs).                                     *
   * ------------------------------------------------------------------ */
  function Region() {
    this.y = null;
    this.cb = null;
    this.cr = null;
    this.x0 = 0;
    this.y0 = 0;
    this.w = 0;
    this.h = 0;
  }
  /* Luminance alone cannot see a card whose brightness matches skin (a mid
     grey or pastel card). Keeping the colour-difference channels lets the
     edge search fall back on hue when brightness contrast is gone. */
  Region.prototype.fill = function (ctx, x0, y0, w, h) {
    x0 = Math.max(0, Math.floor(x0));
    y0 = Math.max(0, Math.floor(y0));
    w = Math.max(1, Math.ceil(w));
    h = Math.max(1, Math.ceil(h));
    var img = ctx.getImageData(x0, y0, w, h);
    var n = w * h;
    if (!this.y || this.y.length < n) {
      this.y = new Float32Array(n);
      this.cb = new Float32Array(n);
      this.cr = new Float32Array(n);
    }
    var d = img.data;
    for (var i = 0, j = 0; i < n; i++, j += 4) {
      var r = d[j],
        g = d[j + 1],
        b = d[j + 2];
      this.y[i] = 0.299 * r + 0.587 * g + 0.114 * b;
      this.cb[i] = -0.168736 * r - 0.331264 * g + 0.5 * b + 128;
      this.cr[i] = 0.5 * r - 0.418688 * g - 0.081312 * b + 128;
    }
    this.x0 = x0;
    this.y0 = y0;
    this.w = w;
    this.h = h;
  };
  Region.prototype.inside = function (x, y) {
    x -= this.x0;
    y -= this.y0;
    return !(x < 0 || y < 0 || x > this.w - 2 || y > this.h - 2);
  };
  Region.prototype.lerp = function (arr, x, y) {
    x -= this.x0;
    y -= this.y0;
    if (x < 0 || y < 0 || x > this.w - 2 || y > this.h - 2) return -1;
    var x0 = x | 0,
      y0 = y | 0;
    var fx = x - x0,
      fy = y - y0;
    var i = y0 * this.w + x0;
    var a = arr[i],
      b = arr[i + 1],
      c = arr[i + this.w],
      d = arr[i + this.w + 1];
    return a + (b - a) * fx + (c - a) * fy + (a - b - c + d) * fx * fy;
  };
  Region.prototype.at = function (x, y) {
    return this.lerp(this.y, x, y);
  };

  /* Centre of mass of the gradient ridge — more accurate than a 3-point
     parabola when the edge is spread over more than one sample. */
  function subCentroid(g, i, n) {
    var lo = Math.max(2, i - 2),
      hi = Math.min(n - 2, i + 2);
    var base = Math.min(g[lo], g[hi]);
    var num = 0,
      den = 0;
    for (var k = lo; k <= hi; k++) {
      var w = g[k] - base;
      if (w <= 0) continue;
      num += w * (k - i);
      den += w;
    }
    return den > 0 ? num / den : 0;
  }

  /* reusable scan buffers — one allocation for the life of the page */
  var SCRATCH = [];
  function scratch(slot, n) {
    var a = SCRATCH[slot];
    if (!a || a.length < n) SCRATCH[slot] = a = new Float32Array(n);
    return a;
  }

  /* ------------------------------------------------------------------ *
   * Card edge detection                                                 *
   * ------------------------------------------------------------------ */
  function cardBand(eyeL, eyeR) {
    var dx = eyeR.x - eyeL.x,
      dy = eyeR.y - eyeL.y;
    var L = Math.hypot(dx, dy);
    if (!(L > 20)) return null;
    var ux = dx / L,
      uy = dy / L;
    return {
      L: L,
      ux: ux,
      uy: uy,
      px: -uy,
      py: ux,
      cx: (eyeL.x + eyeR.x) / 2,
      cy: (eyeL.y + eyeR.y) / 2
    };
  }

  var CHROMA_W = 1.35;

  /* prev: {sl, sr} from the previous frame (tracking mode — search near the
     last known edges with a lower bar, because a card cannot teleport).
     relaxed: only ever used to decide whether to SHOW "card found" in the UI,
     never to decide whether a frame is good enough to measure from. */
  function detectCard(reg, eyeL, eyeR, prev, relaxed) {
    var b = cardBand(eyeL, eyeR);
    if (!b) return null;
    var L = b.L,
      ux = b.ux,
      uy = b.uy,
      pxv = b.px,
      pyv = b.py,
      cx = b.cx,
      cy = b.cy;

    var step = 0.5;
    var span = 1.25 * L;
    var n = Math.round((2 * span) / step);
    var minHalf = 0.42 * L,
      maxHalf = 1.12 * L;

    var loL = -maxHalf,
      hiL = -minHalf,
      loR = minHalf,
      hiR = maxHalf;
    if (prev) {
      var pad = 0.1 * L;
      loL = Math.max(loL, prev.sl - pad);
      hiL = Math.min(hiL, prev.sl + pad);
      loR = Math.max(loR, prev.sr - pad);
      hiR = Math.min(hiR, prev.sr + pad);
      if (hiL <= loL || hiR <= loR) prev = null;
    }

    var baseThr = relaxed ? 3 : 5;
    var noiseK = relaxed ? 3 : 4;
    if (prev) {
      baseThr *= 0.7;
      noiseK *= 0.8;
    }

    var pY = scratch(0, n + 1),
      pCb = scratch(1, n + 1),
      pCr = scratch(2, n + 1),
      grad = scratch(3, n + 1),
      sortBuf = scratch(4, n + 1);

    var lefts = [],
      rights = [],
      strengths = [];
    var NL = 13;

    for (var li = 0; li < NL; li++) {
      var t = -(0.42 + (0.58 * li) / (NL - 1)) * L;
      var ox = cx + pxv * t,
        oy = cy + pyv * t;

      var bad = false;
      for (var k = 0; k <= n; k++) {
        var s = -span + k * step;
        var sx = ox + ux * s,
          sy = oy + uy * s;
        if (!reg.inside(sx, sy)) {
          bad = true;
          break;
        }
        pY[k] = reg.lerp(reg.y, sx, sy);
        pCb[k] = reg.lerp(reg.cb, sx, sy);
        pCr[k] = reg.lerp(reg.cr, sx, sy);
      }
      if (bad) continue;

      /* colour edge strength: whichever channel actually sees the boundary */
      var m = 0;
      for (var k1 = 1; k1 < n; k1++) {
        var gy = Math.abs(pY[k1 + 1] - pY[k1 - 1]);
        var gb = CHROMA_W * Math.abs(pCb[k1 + 1] - pCb[k1 - 1]);
        var gr = CHROMA_W * Math.abs(pCr[k1 + 1] - pCr[k1 - 1]);
        grad[k1] = gy > gb ? (gy > gr ? gy : gr) : gb > gr ? gb : gr;
        if (k1 % 3 === 0) sortBuf[m++] = grad[k1];
      }
      grad[0] = grad[n] = 0;

      /* adapt the bar to how noisy this particular line is (sorted in place,
         no per-frame allocation) */
      var view = sortBuf.subarray(0, m);
      view.sort();
      var typical = m % 2 ? view[m >> 1] : (view[(m >> 1) - 1] + view[m >> 1]) / 2;
      var thr = Math.max(baseThr, noiseK * typical);

      var bestL = -1,
        bestLv = 0,
        bestR = -1,
        bestRv = 0;
      for (var k2 = 2; k2 < n - 1; k2++) {
        var s2 = -span + k2 * step;
        var a = grad[k2];
        if (s2 >= loL && s2 <= hiL) {
          if (a > bestLv) {
            bestLv = a;
            bestL = k2;
          }
        } else if (s2 >= loR && s2 <= hiR) {
          if (a > bestRv) {
            bestRv = a;
            bestR = k2;
          }
        }
      }
      if (bestL < 1 || bestR < 1 || bestLv < thr || bestRv < thr) continue;

      var sl = -span + (bestL + subCentroid(grad, bestL, n)) * step;
      var sr = -span + (bestR + subCentroid(grad, bestR, n)) * step;

      var width = sr - sl;
      if (width < 1.0 * L || width > 1.95 * L) continue;
      if (Math.abs((sr + sl) / 2) > 0.32 * L) continue;

      lefts.push(sl);
      rights.push(sr);
      strengths.push(Math.min(bestLv, bestRv));
    }

    var minLines = relaxed ? 4 : 5;
    if (lefts.length < minLines) return null;

    var mL = median(lefts),
      mR = median(rights);
    var keptW = [],
      keptS = [];
    for (var i2 = 0; i2 < lefts.length; i2++) {
      if (Math.abs(lefts[i2] - mL) < 0.035 * L && Math.abs(rights[i2] - mR) < 0.035 * L) {
        keptW.push(rights[i2] - lefts[i2]);
        keptS.push(strengths[i2]);
      }
    }
    if (keptW.length < (relaxed ? 3 : 4)) return null;

    var agree = keptW.length / lefts.length;
    var strength = median(keptS);
    var tMid = -0.7 * L;
    return {
      width: median(keptW),
      sl: mL,
      sr: mR,
      left: { x: cx + pxv * tMid + ux * mL, y: cy + pyv * tMid + uy * mL },
      right: { x: cx + pxv * tMid + ux * mR, y: cy + pyv * tMid + uy * mR },
      confidence: Math.min(1, agree * Math.min(1, strength / 14))
    };
  }

  /* ------------------------------------------------------------------ *
   * MediaPipe loading (lazy, with real download progress + cache)       *
   * ------------------------------------------------------------------ */
  function preconnect(href) {
    if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = href;
    l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  }

  function fetchModel(onProgress) {
    var cacheRef = null;
    var open = typeof caches !== 'undefined' ? caches.open('pdm-mp-v1').catch(function () {
      return null;
    }) : Promise.resolve(null);

    return open
      .then(function (c) {
        cacheRef = c;
        return c ? c.match(MP_MODEL).catch(function () {
          return null;
        }) : null;
      })
      .then(function (hit) {
        if (hit) return hit.arrayBuffer().then(function (buf) {
          onProgress(1);
          return new Uint8Array(buf);
        });

        return fetch(MP_MODEL).then(function (res) {
          if (!res.ok) throw new Error('model ' + res.status);
          var total = parseInt(res.headers.get('content-length') || '0', 10);
          if (!res.body || !res.body.getReader || !total) {
            return res.arrayBuffer().then(function (buf) {
              onProgress(1);
              if (cacheRef) cacheRef.put(MP_MODEL, new Response(buf)).catch(function () {});
              return new Uint8Array(buf);
            });
          }
          var reader = res.body.getReader();
          var chunks = [];
          var loaded = 0;
          var pump = function () {
            return reader.read().then(function (r) {
              if (r.done) {
                var out = new Uint8Array(loaded);
                var off = 0;
                for (var i = 0; i < chunks.length; i++) {
                  out.set(chunks[i], off);
                  off += chunks[i].length;
                }
                if (cacheRef) cacheRef.put(MP_MODEL, new Response(out)).catch(function () {});
                return out;
              }
              chunks.push(r.value);
              loaded += r.value.length;
              onProgress(Math.min(0.99, loaded / total));
              return pump();
            });
          };
          return pump();
        });
      });
  }

  /* ------------------------------------------------------------------ *
   * Component                                                           *
   * ------------------------------------------------------------------ */
  function PDM(root) {
    this.root = root;
    var lang = root.getAttribute('data-lang') || 'el';
    if (lang !== 'el' && lang !== 'en') lang = 'el';
    this.t = STR[lang];
    this.lang = lang;
    this.targetFrames = parseInt(root.getAttribute('data-frames'), 10) || 24;
    this.geom = new Geometry(
      root.getAttribute('data-fov-deg'),
      root.getAttribute('data-plane-offset'),
      root.getAttribute('data-eye-rotation')
    );
    /* Flat empirical offset against optician readings. Deliberately kept apart
       from the physical constants above: those are defensible anatomy, this is
       the leftover we have not explained yet. Because it is flat it cannot mask
       a distance-dependent error — if the residual grows on close-up readings,
       the field data will still show it and the fix belongs in the FOV. */
    this.calib = CALIB_MM + clampNum(root.getAttribute('data-calibration'), -5, 5, 0);
    this.autoEnabled = root.getAttribute('data-auto') !== 'false';
    this.debug = debugOn();

    this.screens = {};
    all(root, '[data-pdm-screen]').forEach(
      function (el) {
        this.screens[el.getAttribute('data-pdm-screen')] = el;
      }.bind(this)
    );

    this.video = $(root, '[data-pdm-video]');
    this.overlay = $(root, '[data-pdm-overlay]');
    this.stillCv = $(root, '[data-pdm-still]');
    this.loupe = $(root, '[data-pdm-loupe]');
    this.coachEl = $(root, '[data-pdm-coach]');
    this.progressEls = all(root, '[data-pdm-progress]');
    this.barEls = all(root, '[data-pdm-bar]');
    this.measureBtn = $(root, '[data-pdm-measure]');
    this.ringEl = $(root, '[data-pdm-ring]');
    this.loadEl = $(root, '[data-pdm-loading]');
    this.loadTxt = $(root, '[data-pdm-loading-txt]');
    this.loadBar = $(root, '[data-pdm-loading-bar]');

    this.work = document.createElement('canvas');
    this.workCtx = this.work.getContext('2d', { willReadFrequently: true });
    this.region = new Region();
    this.best = null;
    this.samples = [];
    this.state = 'intro';
    this.collecting = false;
    this.countdown = 0;
    this.fps = 0;
    this.track = null;
    this.readySince = 0;
    this.lastOkAt = 0;
    this.lastCardAt = 0;
    this.cardTroubleAt = 0;
    this.coachKey = null;
    this.coachAt = 0;

    this.applyTexts();
    this.bind();
    this.go('intro');
    if (this.debug) this.mountDebug();

    var pre = this.precheck();
    if (pre) this.fail(pre);
  }

  PDM.prototype.applyTexts = function () {
    var t = this.t;
    all(this.root, '[data-pdm-t]').forEach(function (el) {
      var k = el.getAttribute('data-pdm-t');
      if (t[k]) el.textContent = t[k];
    });
  };

  PDM.prototype.precheck = function () {
    if (this.debug) return null;
    if (isInAppBrowser()) return 'eInApp';
    if (!window.isSecureContext && location.hostname !== 'localhost') return 'eHttps';
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return 'eUnsupported';
    return null;
  };

  /* --------------------------- Screens ------------------------------ */

  /* The storefront has site-wide fixed overlays (cookie banner, FAQ bubble,
     chat widget). They sit exactly where our primary button is, so while a
     full-screen step is running we hide them and restore them afterwards. */
  PDM.prototype.eachForeignFixed = function (fn) {
    var self = this;
    var nodes = document.body ? document.body.querySelectorAll('*') : [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el === self.root || self.root.contains(el) || el.contains(self.root)) continue;
      if (el.className && String(el.className).indexOf('pdm-dbg') >= 0) continue;
      var cs;
      try {
        cs = getComputedStyle(el);
      } catch (e) {
        continue;
      }
      if (cs.position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4) continue;
      fn(el, cs, r);
    }
  };

  PDM.prototype.setOverlaysHidden = function (on) {
    if (on) {
      if (this.hiddenEls) return;
      var list = [];
      this.eachForeignFixed(function (el, cs) {
        if (cs.visibility === 'hidden' || cs.display === 'none') return;
        list.push({ el: el, prev: el.style.getPropertyValue('visibility'), pri: el.style.getPropertyPriority('visibility') });
        el.style.setProperty('visibility', 'hidden', 'important');
      });
      this.hiddenEls = list;
    } else if (this.hiddenEls) {
      this.hiddenEls.forEach(function (o) {
        if (o.prev) o.el.style.setProperty('visibility', o.prev, o.pri);
        else o.el.style.removeProperty('visibility');
      });
      this.hiddenEls = null;
    }
  };

  /* Height of any wide bar pinned to the bottom of the viewport, so the
     sticky CTA on the in-page screens can sit above it. */
  PDM.prototype.measureObstruction = function () {
    var vh = window.innerHeight,
      vw = window.innerWidth,
      max = 0;
    this.eachForeignFixed(function (el, cs, r) {
      if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') return;
      if (r.width < vw * 0.5) return;
      if (r.bottom < vh - 6 || r.top > vh) return;
      max = Math.max(max, vh - r.top);
    });
    this.root.style.setProperty('--pdm-obstruct', Math.round(Math.min(max, vh * 0.4)) + 'px');
  };

  PDM.prototype.lockScroll = function (on) {
    var b = document.body;
    if (on === this.scrollLocked) return;
    this.scrollLocked = on;
    if (on) {
      this.savedScroll = window.pageYOffset || 0;
      this.savedBody = { position: b.style.position, top: b.style.top, width: b.style.width, overflow: b.style.overflow };
      b.style.position = 'fixed';
      b.style.top = -this.savedScroll + 'px';
      b.style.width = '100%';
      b.style.overflow = 'hidden';
    } else if (this.savedBody) {
      b.style.position = this.savedBody.position;
      b.style.top = this.savedBody.top;
      b.style.width = this.savedBody.width;
      b.style.overflow = this.savedBody.overflow;
      window.scrollTo(0, this.savedScroll || 0);
    }
  };

  PDM.prototype.go = function (name) {
    this.state = name;
    var el = this.screens[name];
    Object.keys(this.screens).forEach(
      function (k) {
        this.screens[k].hidden = k !== name;
      }.bind(this)
    );
    var fs = !!(el && el.hasAttribute('data-pdm-fs'));
    this.lockScroll(fs);
    this.setOverlaysHidden(fs);
    if (!fs) this.measureObstruction();

    var idx = { intro: 1, capture: 2, verify: 3 }[name];
    var head = $(this.root, '[data-pdm-head]');
    if (head) head.hidden = name !== 'intro';
    /* The page intro is marketing copy for someone who has not started yet;
       it would only be noise above a result. It ships visible in the HTML so
       crawlers and no-JS visitors always read it. */
    all(this.root, '[data-pdm-intro-only]').forEach(function (el) {
      el.hidden = name !== 'intro';
    });
    if (idx) {
      var label = fmt(this.t.step, { n: idx });
      this.progressEls.forEach(function (p) {
        p.textContent = label;
      });
      this.barEls.forEach(function (bEl) {
        bEl.style.width = (idx / 3) * 100 + '%';
      });
    }
    if (!fs) {
      /* Never yank the page on first paint — the visitor has just landed and
         is reading the intro. Only later transitions scroll the tool back. */
      if (this.booted) {
        try {
          this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {}
      }
      var self = this;
      setTimeout(function () {
        self.measureObstruction();
        self.ensureActionVisible();
      }, 650);
    }
    this.booted = true;
  };

  /* Screens without a sticky footer (the error screen) can still land under a
     site-wide bottom bar on very short viewports — nudge them clear. */
  PDM.prototype.ensureActionVisible = function () {
    var el = this.screens[this.state];
    if (!el || el.hasAttribute('data-pdm-fs')) return;
    var btn = el.querySelector('.pdm-sticky') ? null : el.querySelector('.pdm-btn:not([hidden])');
    if (!btn) return;
    var ob = parseFloat(getComputedStyle(this.root).getPropertyValue('--pdm-obstruct')) || 0;
    var over = btn.getBoundingClientRect().bottom - (window.innerHeight - ob - 10);
    if (over > 0) {
      try {
        window.scrollBy({ top: over, behavior: 'smooth' });
      } catch (e) {
        window.scrollBy(0, over);
      }
    }
  };

  PDM.prototype.fail = function (key) {
    this.stopCamera();
    var msg = $(this.root, '[data-pdm-error-msg]');
    if (msg) msg.textContent = this.t[key] || this.t.eUnsupported;
    var retry = $(this.root, '[data-pdm-retry]');
    if (retry) retry.hidden = key === 'eInApp' || key === 'eHttps' || key === 'eUnsupported';
    var copy = $(this.root, '[data-pdm-copylink]');
    if (copy) copy.hidden = key !== 'eInApp';
    this.go('error');
  };

  PDM.prototype.bind = function () {
    var self = this;
    var on = function (sel, fn) {
      all(self.root, sel).forEach(function (el) {
        el.addEventListener('click', fn);
      });
    };

    on('[data-pdm-start]', function () {
      self.startCamera();
    });
    on('[data-pdm-retry]', function () {
      self.startCamera();
    });
    on('[data-pdm-close]', function () {
      self.stopCamera();
      self.go('intro');
    });
    on('[data-pdm-manual]', function () {
      self.captureManualStill();
    });
    on('[data-pdm-verify-back]', function () {
      self.startCamera();
    });
    on('[data-pdm-verify-next]', function () {
      self.showResult();
    });
    on('[data-pdm-again]', function () {
      self.startCamera();
    });
    on('[data-pdm-copylink]', function (e) {
      self.copy(location.href, e.currentTarget);
    });
    on('[data-pdm-copy]', function (e) {
      self.copy(self.copyText || '', e.currentTarget);
    });

    if (this.measureBtn)
      this.measureBtn.addEventListener('click', function () {
        if (self.measureBtn.disabled || self.collecting) return;
        self.beginCollect();
      });

    if (this.stillCv) this.bindEditor();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (self.state === 'capture') {
          self.wasCapturing = true;
          self.stopCamera();
        }
      } else if (self.wasCapturing && self.state === 'capture') {
        self.wasCapturing = false;
        self.startCamera();
      }
    });

    window.addEventListener('pagehide', function () {
      self.stopCamera();
      self.lockScroll(false);
      self.setOverlaysHidden(false);
    });

    var relayout = function () {
      if (self.state === 'verify') self.drawStill();
      else self.measureObstruction();
    };

    /* cookie banners and chat widgets mount late — re-measure a few times */
    [1200, 3500, 7000].forEach(function (ms) {
      setTimeout(function () {
        if (self.state !== 'capture' && self.state !== 'verify') self.measureObstruction();
      }, ms);
    });
    window.addEventListener('resize', relayout);
    window.addEventListener('orientationchange', function () {
      setTimeout(relayout, 250);
    });
  };

  PDM.prototype.copy = function (text, btn) {
    var self = this;
    var done = function () {
      var old = btn.textContent;
      btn.textContent = self.t.resCopied;
      setTimeout(function () {
        btn.textContent = old;
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {}
      document.body.removeChild(ta);
    }
  };

  /* -------------------------- Engine -------------------------------- */
  PDM.prototype.showLoading = function (key, pct) {
    if (!this.loadEl) return;
    if (this.coachEl) this.coachEl.style.visibility = key === null ? '' : 'hidden';
    if (key === null) {
      this.loadEl.hidden = true;
      return;
    }
    this.loadEl.hidden = false;
    if (this.loadTxt) this.loadTxt.textContent = fmt(this.t[key], { p: Math.round((pct || 0) * 100) });
    if (this.loadBar) this.loadBar.style.width = Math.round((pct || 0) * 100) + '%';
  };

  PDM.prototype.loadEngine = function () {
    if (this.enginePromise) return this.enginePromise;
    var self = this;
    var dyn;
    try {
      dyn = new Function('u', 'return import(u);');
    } catch (e) {
      this.engineSettled = true;
      return Promise.resolve(null);
    }
    preconnect('https://cdn.jsdelivr.net');
    preconnect('https://storage.googleapis.com');
    this.engineStart = performance.now();
    this.showLoading('loadLib', 0.04);

    this.enginePromise = dyn(MP_CDN)
      .then(function (mod) {
        self.showLoading('loadLib', 0.12);
        return mod.FilesetResolver.forVisionTasks(MP_CDN + '/wasm').then(function (fs) {
          return fetchModel(function (p) {
            self.showLoading('loadModel', 0.15 + p * 0.8);
          }).then(function (bytes) {
            self.showLoading('loadDone', 1);
            return mod.FaceLandmarker.createFromOptions(fs, {
              baseOptions: { modelAssetBuffer: bytes, delegate: 'GPU' },
              runningMode: 'VIDEO',
              numFaces: 1
            });
          });
        });
      })
      .then(function (lm) {
        self.engine = lm;
        self.engineSettled = true;
        self.showLoading(null);
        return lm;
      })
      .catch(function () {
        self.engine = null;
        self.engineSettled = true;
        self.showLoading(null);
        return null;
      });
    return this.enginePromise;
  };

  /* --------------------------- Camera ------------------------------- */
  PDM.prototype.startCamera = function () {
    var self = this;
    var pre = this.precheck();
    if (pre) return this.fail(pre);

    this.stopCamera();
    this.samples = [];
    this.best = null;
    this.collecting = false;
    this.countdown = 0;
    this.stuckSince = 0;
    this.lastRes = null;
    this.track = null;
    this.readySince = 0;
    this.lastOkAt = 0;
    this.lastCardAt = 0;
    this.cardTroubleAt = 0;
    this.coachKey = null;
    this.coachAt = 0;
    if (this.measureBtn) this.measureBtn.disabled = true;
    var manualBtn = $(this.root, '[data-pdm-manual]');
    if (manualBtn) manualBtn.hidden = true;
    this.setCoach('cNoFace', false);
    this.go('capture');

    if (this.autoEnabled && !this.engineSettled) this.loadEngine();
    else this.showLoading(null);

    var tryGet = function (constraints) {
      return navigator.mediaDevices.getUserMedia(constraints);
    };

    tryGet({
      audio: false,
      video: {
        facingMode: 'user',
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30, max: 30 }
      }
    })
      .catch(function (err) {
        if (err && (err.name === 'OverconstrainedError' || err.name === 'NotFoundError')) {
          return tryGet({ audio: false, video: { facingMode: 'user' } });
        }
        throw err;
      })
      .then(function (stream) {
        self.stream = stream;
        var v = self.video;
        v.srcObject = stream;
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.muted = true;
        var kick = function () {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        };
        kick();
        v.addEventListener('loadedmetadata', kick, { once: true });
        self.startLoop();
      })
      .catch(function (err) {
        var n = err && err.name;
        if (n === 'NotAllowedError' || n === 'SecurityError') self.fail('eDenied');
        else if (n === 'NotFoundError' || n === 'OverconstrainedError') self.fail('eNoCam');
        else if (n === 'NotReadableError' || n === 'AbortError') self.fail('eBusy');
        else self.fail('eUnsupported');
      });
  };

  PDM.prototype.stopCamera = function () {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = 0;
    this.loopToken++;
    if (this.stream) {
      this.stream.getTracks().forEach(function (tr) {
        tr.stop();
      });
      this.stream = null;
    }
    if (this.video) {
      try {
        this.video.pause();
      } catch (e) {}
      this.video.srcObject = null;
    }
  };

  PDM.prototype.startLoop = function () {
    var self = this;
    var v = this.video;
    this.loopToken = (this.loopToken || 0) + 1;
    var token = this.loopToken;
    var last = 0;

    var run = function (now) {
      if (self.state !== 'capture' || token !== self.loopToken) return false;
      now = now || performance.now();
      if (now - last >= MIN_FRAME_MS) {
        if (last) self.fps = self.fps ? self.fps * 0.85 + (1000 / (now - last)) * 0.15 : 1000 / (now - last);
        last = now;
        self.frame();
      }
      return true;
    };

    if (v.requestVideoFrameCallback) {
      var vcb = function (now) {
        if (!run(now)) return;
        v.requestVideoFrameCallback(vcb);
      };
      v.requestVideoFrameCallback(vcb);
    } else {
      var tick = function (now) {
        if (!run(now)) return;
        self.rafId = requestAnimationFrame(tick);
      };
      this.rafId = requestAnimationFrame(tick);
    }
  };

  /* ------------------------ Frame analysis -------------------------- */
  PDM.prototype.frame = function () {
    var v = this.video;
    if (!v || v.readyState < 2 || !v.videoWidth) return;

    var vw = v.videoWidth,
      vh = v.videoHeight;
    var W = Math.min(WORK_W, vw);
    var H = Math.round((W * vh) / vw);
    if (this.work.width !== W || this.work.height !== H) {
      this.work.width = W;
      this.work.height = H;
    }

    var res = { W: W, H: H, ok: false };

    if (!this.engine) {
      var waiting = this.autoEnabled && this.enginePromise && !this.engineSettled;
      if (waiting) {
        if (this.measureBtn) this.measureBtn.disabled = true;
        this.setCoach('', false);
      } else {
        if (this.measureBtn) this.measureBtn.disabled = false;
        this.setCoach('cTapReady', true);
      }
      this.drawOverlay(res);
      return;
    }

    var ts = performance.now();
    if (ts <= (this.lastTs || 0)) ts = this.lastTs + 1;
    this.lastTs = ts;
    var out;
    try {
      out = this.engine.detectForVideo(v, ts);
    } catch (e) {
      return;
    }
    var lms = out && out.faceLandmarks && out.faceLandmarks[0];
    if (!lms || lms.length < 478) {
      this.track = null;
      this.tick(res, { usable: false, strict: false, reason: 'cNoFace', cardFound: false });
      return;
    }

    var P = function (i) {
      return { x: lms[i].x * W, y: lms[i].y * H };
    };
    var irisCenter = function (a) {
      var sx = 0,
        sy = 0;
      for (var i = a; i < a + 4; i++) {
        sx += lms[i].x * W;
        sy += lms[i].y * H;
      }
      return { x: sx / 4, y: sy / 4 };
    };
    var irisDiam = function (a, c) {
      var s = 0;
      for (var i = a; i < a + 4; i++) s += dist({ x: lms[i].x * W, y: lms[i].y * H }, c);
      return (s / 4) * 2;
    };

    var cA = irisCenter(469),
      cB = irisCenter(474);
    var eyeL = cA.x <= cB.x ? cA : cB;
    var eyeR = cA.x <= cB.x ? cB : cA;
    var irisPx = (irisDiam(469, cA) + irisDiam(474, cB)) / 2;
    var pupilPx = dist(eyeL, eyeR);
    res.eyeL = eyeL;
    res.eyeR = eyeR;
    res.irisPx = irisPx;
    res.pupilPx = pupilPx;
    res.bridge = P(168);

    var roll = (Math.atan2(eyeR.y - eyeL.y, eyeR.x - eyeL.x) * 180) / Math.PI;
    var nose = P(1),
      fL = P(234),
      fR = P(454);
    var dl = dist(nose, fL),
      dr = dist(nose, fR);
    var yawA = (dr - dl) / (dr + dl);

    var gaze = 0;
    try {
      var pairs = [
        [33, 133, cA.x < cB.x ? cA : cB],
        [362, 263, cA.x < cB.x ? cB : cA]
      ];
      var gs = pairs.map(function (p) {
        var a = P(p[0]),
          b = P(p[1]),
          c = p[2];
        var vx = b.x - a.x,
          vy = b.y - a.y;
        var len2 = vx * vx + vy * vy;
        if (!len2) return 0;
        var u = ((c.x - a.x) * vx + (c.y - a.y) * vy) / len2;
        return Math.abs(u - 0.5);
      });
      gaze = Math.max(gs[0], gs[1]);
    } catch (e) {}

    /* Read back only the forehead band + eye strip instead of the whole
       frame — roughly 10x less pixel traffic per analysed frame. */
    this.workCtx.drawImage(v, 0, 0, W, H);
    var cxm = (eyeL.x + eyeR.x) / 2,
      cym = (eyeL.y + eyeR.y) / 2;
    var pad = 1.45 * pupilPx;
    var rx = cxm - pad,
      rw = pad * 2;
    var ry = cym - 1.15 * pupilPx,
      rh = 1.55 * pupilPx;
    if (rx < 0) {
      rw += rx;
      rx = 0;
    }
    if (ry < 0) {
      rh += ry;
      ry = 0;
    }
    rw = Math.min(rw, W - rx);
    rh = Math.min(rh, H - ry);
    if (rw < 8 || rh < 8) {
      this.tick(res, { usable: false, strict: false, reason: 'cNoFace', cardFound: false });
      return;
    }
    this.region.fill(this.workCtx, rx, ry, rw, rh);
    var reg = this.region;

    var bx0 = Math.max(reg.x0 + 1, Math.round(Math.min(eyeL.x, eyeR.x) - pupilPx * 0.35));
    var bx1 = Math.min(reg.x0 + reg.w - 2, Math.round(Math.max(eyeL.x, eyeR.x) + pupilPx * 0.35));
    var by0 = Math.max(reg.y0 + 1, Math.round(cym - pupilPx * 0.16));
    var by1 = Math.min(reg.y0 + reg.h - 2, Math.round(cym + pupilPx * 0.16));
    var sum = 0,
      cnt = 0,
      lap = 0;
    for (var y = by0; y <= by1; y++) {
      for (var x = bx0; x <= bx1; x++) {
        var c0 = reg.at(x, y);
        if (c0 < 0) continue;
        sum += c0;
        cnt++;
        lap += Math.abs(4 * c0 - reg.at(x - 1, y) - reg.at(x + 1, y) - reg.at(x, y - 1) - reg.at(x, y + 1));
      }
    }
    var bright = cnt ? sum / cnt : 0;
    var sharp = cnt ? lap / cnt : 0;

    /* Two-tier detection. The relaxed pass only decides what the UI says;
       only STRICT frames are ever allowed into the measurement. */
    var track = this.track && performance.now() - this.track.at < 700 ? this.track : null;
    var card = detectCard(reg, eyeL, eyeR, track, false);
    var strictCard = !!card;
    if (!card) card = detectCard(reg, eyeL, eyeR, track, true);
    res.card = card;
    if (card) this.track = { sl: card.sl, sr: card.sr, at: performance.now() };

    /* Gate on the estimated distance, not on how much of the frame the card
       covers: the same customer at the same distance fills a very different
       share of a portrait frame than of a landscape one. */
    var zCard = card ? this.geom.solve(card.width, W, H).zCard : 0;
    res.zCard = zCard;
    var g = { usable: false, strict: false, reason: null, cardFound: false };

    /* usable = good enough to tell the customer "you are lined up" */
    if (bright < 28) g.reason = 'cDark';
    else if (bright > 248) g.reason = 'cBright';
    else if (Math.abs(roll) > 11) g.reason = 'cRoll';
    else if (Math.abs(yawA) > 0.13) g.reason = 'cYaw';
    else if (gaze > 0.24) g.reason = 'cGaze';
    else if (!card || card.confidence < 0.28) g.reason = 'cCard';
    else if (zCard < 270) g.reason = 'cNear';
    else if (zCard > 800) g.reason = 'cFar';
    else if (sharp < 1.2) g.reason = 'cBlur';
    else g.usable = true;

    g.cardFound = !!card && card.confidence >= 0.28;

    /* strict = good enough to compute millimetres from */
    if (
      g.usable &&
      strictCard &&
      bright >= 35 &&
      bright <= 240 &&
      Math.abs(roll) <= 8 &&
      Math.abs(yawA) <= 0.1 &&
      gaze <= 0.18 &&
      card.confidence >= 0.45 &&
      /* Kept a little wider than the coaching thresholds so a customer who is
         told "you are lined up" always produces measurable frames. Roughly
         27-84 cm from the lens. */
      zCard >= 250 &&
      zCard <= 820 &&
      sharp >= 2
    ) {
      g.strict = true;
      res.ok = true;
      res.score = card.confidence * Math.min(1, sharp / 12);
    }

    this.tick(res, g);
  };

  /* ---------------------- Capture state machine ---------------------- *
   * Detection on a real phone flickers. Rather than making the customer
   * race a button that keeps disabling itself, we hold state with
   * hysteresis, start the measurement automatically once things look
   * right, and then keep only the frames that pass the strict bar.
   * ------------------------------------------------------------------ */
  var READY_HOLD_MS = 700;
  var COUNTDOWN_S = 2;
  var CARD_STICKY_MS = 1500;
  var COLLECT_TIMEOUT_MS = 10000;
  var MIN_SAMPLES = 8;

  PDM.prototype.tick = function (res, g) {
    var now = performance.now();
    this.lastRes = res;

    if (g.cardFound) this.lastCardAt = now;
    if (g.usable) {
      this.lastOkAt = now;
      if (!this.readySince) this.readySince = now;
    } else if (!this.lastOkAt || now - this.lastOkAt > 500) {
      this.readySince = 0;
    }

    /* is the card missing specifically, for long enough to blame it? */
    if (g.reason !== 'cCard') this.cardTroubleAt = 0;
    else if (!this.cardTroubleAt) this.cardTroubleAt = now;
    var reason = g.reason;
    if (reason === 'cCard' && this.cardTroubleAt && now - this.cardTroubleAt > 4000) reason = 'cCardColor';

    var cardSticky = this.lastCardAt && now - this.lastCardAt < CARD_STICKY_MS;

    if (!this.collecting) {
      this.stuckSince = this.stuckSince || now;
      if (g.usable) this.stuckSince = now;
      else if (now - this.stuckSince > 12000) this.offerManual();

      if (this.measureBtn) this.measureBtn.disabled = !(cardSticky && this.engine);

      if (this.readySince && now - this.readySince > READY_HOLD_MS) {
        this.beginCollect();
      } else {
        this.setCoach(g.usable ? 'cReady' : reason || 'cNoFace', !!g.usable);
        this.drawOverlay(res);
      }
      if (!this.collecting) return;
    }

    /* --- hold-still countdown --- */
    if (this.countdown > 0) {
      if (!g.usable && this.lastOkAt && now - this.lastOkAt > 500) this.countdownAt = now;
      var left = COUNTDOWN_S - (now - this.countdownAt) / 1000;
      if (left > 0) {
        this.setCoach('cOk', true, Math.ceil(left));
        this.drawOverlay(res, 0);
        return;
      }
      this.countdown = 0;
      this.collectStart = now;
    }

    /* --- opportunistic collection: keep only measurable frames --- */
    if (g.strict) {
      this.samples.push({
        ratioCard: res.pupilPx / res.card.width,
        ratioIris: res.pupilPx / res.irisPx,
        cardPx: res.card.width,
        fw: res.W,
        fh: res.H,
        score: res.score
      });
      if (!this.best || res.score > this.best.score) this.captureStill(res);
    }

    var got = this.samples.length;
    if (got >= this.targetFrames) return this.finishCollect();

    var elapsed = now - this.collectStart;
    if (elapsed > COLLECT_TIMEOUT_MS) {
      if (got >= MIN_SAMPLES) return this.finishCollect();
      this.collecting = false;
      this.countdown = 0;
      this.readySince = 0;
      this.setCoach('cFew', false);
      this.coachAt = now + 2000;
      this.offerManual();
      this.drawOverlay(res);
      return;
    }

    /* Once collecting, stay reassuring: only complain if nothing measurable
       has arrived for a while, otherwise the progress ring tells the story. */
    if (g.strict) this.lastStrictAt = now;
    if (g.strict || (this.lastStrictAt && now - this.lastStrictAt < 1500)) this.setCoach('capHold', true);
    else this.setCoach(reason || 'capHold', false);
    this.drawOverlay(res, Math.min(1, got / this.targetFrames));
  };

  PDM.prototype.beginCollect = function () {
    this.samples = [];
    this.best = null;
    this.collecting = true;
    this.countdown = COUNTDOWN_S;
    this.countdownAt = performance.now();
    this.collectStart = performance.now();
    this.lastStrictAt = 0;
    if (this.measureBtn) this.measureBtn.disabled = true;
    if (!this.engine) this.captureManualStill();
  };

  PDM.prototype.finishCollect = function () {
    this.collecting = false;
    this.countdown = 0;
    this.stopCamera();
    this.showVerify();
  };

  PDM.prototype.offerManual = function () {
    var btn = $(this.root, '[data-pdm-manual]');
    if (btn && btn.hidden) {
      btn.textContent = this.t.capManual;
      btn.hidden = false;
    }
  };

  PDM.prototype.captureStill = function (res) {
    var v = this.video;
    var cv = document.createElement('canvas');
    cv.width = v.videoWidth;
    cv.height = v.videoHeight;
    cv.getContext('2d').drawImage(v, 0, 0);
    var k = v.videoWidth / res.W;
    this.best = {
      canvas: cv,
      score: res.score,
      bridge: res.bridge ? { x: res.bridge.x * k, y: res.bridge.y * k } : null,
      marks: {
        cardL: { x: res.card.left.x * k, y: res.card.left.y * k },
        cardR: { x: res.card.right.x * k, y: res.card.right.y * k },
        pupL: { x: res.eyeL.x * k, y: res.eyeL.y * k },
        pupR: { x: res.eyeR.x * k, y: res.eyeR.y * k }
      }
    };
  };

  PDM.prototype.captureManualStill = function () {
    var v = this.video;
    if (!v || !v.videoWidth) return;
    var cv = document.createElement('canvas');
    cv.width = v.videoWidth;
    cv.height = v.videoHeight;
    cv.getContext('2d').drawImage(v, 0, 0);
    var w = cv.width,
      h = cv.height;

    var marks = {
      cardL: { x: w * 0.3, y: h * 0.3 },
      cardR: { x: w * 0.7, y: h * 0.3 },
      pupL: { x: w * 0.42, y: h * 0.46 },
      pupR: { x: w * 0.58, y: h * 0.46 }
    };
    var bridge = null;
    var res = this.lastRes;
    if (res && res.eyeL && res.eyeR && res.W) {
      var k = w / res.W;
      marks.pupL = { x: res.eyeL.x * k, y: res.eyeL.y * k };
      marks.pupR = { x: res.eyeR.x * k, y: res.eyeR.y * k };
      if (res.bridge) bridge = { x: res.bridge.x * k, y: res.bridge.y * k };
      if (res.card) {
        marks.cardL = { x: res.card.left.x * k, y: res.card.left.y * k };
        marks.cardR = { x: res.card.right.x * k, y: res.card.right.y * k };
      } else {
        var d0 = dist(marks.pupL, marks.pupR) || 1;
        var ux = (marks.pupR.x - marks.pupL.x) / d0,
          uy = (marks.pupR.y - marks.pupL.y) / d0;
        var mid = {
          x: (marks.pupL.x + marks.pupR.x) / 2 + uy * d0 * 0.7,
          y: (marks.pupL.y + marks.pupR.y) / 2 - ux * d0 * 0.7
        };
        marks.cardL = { x: mid.x - ux * d0 * 0.68, y: mid.y - uy * d0 * 0.68 };
        marks.cardR = { x: mid.x + ux * d0 * 0.68, y: mid.y + uy * d0 * 0.68 };
      }
    }

    this.best = { canvas: cv, score: 0, bridge: bridge, marks: marks };
    this.collecting = false;
    this.samples = [];
    this.stopCamera();
    this.showVerify();
    this.markEdited();
  };

  /* --------------------------- Coaching ----------------------------- */
  /* A coaching message that changes every other frame is worse than no
     message. Good news shows instantly; a new complaint has to wait until
     the previous one has been readable for a moment. */
  PDM.prototype.setCoach = function (key, good, num) {
    var now = performance.now();
    if (key !== this.coachKey) {
      if (!good && this.coachKey && now - this.coachAt < 700) return;
      this.coachKey = key;
      this.coachAt = now;
    }
    var txt = key ? this.t[key] || '' : '';
    if (num) txt = txt + ' ' + num;
    if (this.coachEl) {
      if (this.coachEl.textContent !== txt) this.coachEl.textContent = txt || '\u00a0';
      this.coachEl.setAttribute('data-good', good ? 'true' : 'false');
    }
  };

  PDM.prototype.drawOverlay = function (res, progress) {
    var cv = this.overlay,
      v = this.video;
    if (!cv || !v) return;
    var rect = cv.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var cw = Math.round(rect.width * dpr),
      ch = Math.round(rect.height * dpr);
    if (cv.width !== cw || cv.height !== ch) {
      cv.width = cw;
      cv.height = ch;
    }
    var ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, cw, ch);

    var fw = res.W || v.videoWidth || cw;
    var fh = res.H || v.videoHeight || ch;
    var k = Math.max(cw / fw, ch / fh);
    var offX = (cw - fw * k) / 2;
    var offY = (ch - fh * k) / 2;
    var mx = function (x) {
      return cw - (offX + x * k);
    };
    var my = function (y) {
      return offY + y * k;
    };

    var accent = res.ok ? 'rgba(90,220,140,.95)' : 'rgba(255,255,255,.45)';

    ctx.save();
    ctx.strokeStyle = accent;
    ctx.lineWidth = 2 * dpr;
    ctx.setLineDash([10 * dpr, 10 * dpr]);
    ctx.beginPath();
    ctx.ellipse(cw / 2, ch * 0.54, cw * 0.32, ch * 0.34, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.restore();

    if (res.card && res.eyeL && res.eyeR) {
      ctx.save();
      ctx.strokeStyle = accent;
      ctx.lineWidth = 3 * dpr;
      ctx.beginPath();
      ctx.moveTo(mx(res.card.left.x), my(res.card.left.y));
      ctx.lineTo(mx(res.card.right.x), my(res.card.right.y));
      ctx.stroke();
      ctx.fillStyle = 'rgba(255,60,80,.95)';
      [res.eyeL, res.eyeR].forEach(function (p) {
        ctx.beginPath();
        ctx.arc(mx(p.x), my(p.y), 5 * dpr, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.restore();
    }

    if (this.ringEl) {
      if (progress == null) this.ringEl.hidden = true;
      else {
        this.ringEl.hidden = false;
        this.ringEl.style.setProperty('--p', Math.round(progress * 100));
      }
    }
    if (this.dbgFps) this.dbgFps.textContent = Math.round(this.fps) + ' fps';
  };

  /* --------------------------- Verify ------------------------------- */
  var MARK_KEYS = ['cardL', 'cardR', 'pupL', 'pupR'];

  PDM.prototype.showVerify = function () {
    if (!this.best) return this.startCamera();
    this.editorEdited = false;
    this.origMarks = {};
    var m = this.best.marks;
    for (var i = 0; i < MARK_KEYS.length; i++) {
      var k = MARK_KEYS[i];
      this.origMarks[k] = { x: m[k].x, y: m[k].y };
    }
    this.cropBox = null;
    /* The customer has to look at every dot up close before we let them
       confirm. Grabbing one is enough — it opens the loupe over that exact
       spot, which is the whole point. We never force an actual move, because a
       dot that is already right should stay right. */
    this.inspected = {};
    this.updateVerifyGate();
    var note = $(this.root, '[data-pdm-verify-note]');
    if (note) note.hidden = true;
    this.go('verify');
    var self = this;
    requestAnimationFrame(function () {
      self.drawStill();
    });
  };

  PDM.prototype.inspectedCount = function () {
    var n = 0;
    for (var i = 0; i < MARK_KEYS.length; i++) {
      if (this.inspected && this.inspected[MARK_KEYS[i]]) n++;
    }
    return n;
  };

  PDM.prototype.updateVerifyGate = function () {
    var n = this.inspectedCount();
    var done = n >= MARK_KEYS.length;
    var btn = $(this.root, '[data-pdm-verify-next]');
    if (btn) {
      btn.hidden = !done;
      btn.disabled = !done;
    }
    var el = $(this.root, '[data-pdm-vercount]');
    if (el) {
      el.textContent = done ? this.t.verCheckDone : fmt(this.t.verCheck, { n: n });
      el.setAttribute('data-done', done ? 'true' : 'false');
    }
  };

  /* How far the customer dragged the worst dot, in millimetres of face.
     Below ~1.5 mm the multi-frame average is still the better number; above
     it we trust the human and recompute from the corrected still. */
  PDM.prototype.shiftMM = function () {
    if (!this.origMarks || !this.best) return 0;
    var m = this.best.marks,
      o = this.origMarks;
    var px = dist(m.cardL, m.cardR);
    if (!px) return 0;
    var mmPerPx = CARD_W_MM / px;
    var worst = 0;
    for (var i = 0; i < MARK_KEYS.length; i++) {
      var k = MARK_KEYS[i];
      if (!o[k]) continue;
      worst = Math.max(worst, dist(m[k], o[k]) * mmPerPx);
    }
    return worst;
  };

  /* On a phone the whole photo makes each dot a couple of pixels wide, which
     is far too small to judge. Frame the card and the eyes instead. The box
     is frozen on entry so the picture cannot shift under a dragging finger. */
  PDM.prototype.markBox = function () {
    if (this.cropBox) return this.cropBox;
    var img = this.best.canvas,
      m = this.best.marks;
    var xs = [],
      ys = [];
    for (var i = 0; i < MARK_KEYS.length; i++) {
      xs.push(img.width - m[MARK_KEYS[i]].x);
      ys.push(m[MARK_KEYS[i]].y);
    }
    var x0 = Math.min.apply(null, xs),
      x1 = Math.max.apply(null, xs);
    var y0 = Math.min.apply(null, ys),
      y1 = Math.max.apply(null, ys);
    var padX = Math.max((x1 - x0) * 0.32, img.width * 0.05);
    var padY = Math.max((y1 - y0) * 0.4, img.height * 0.05);
    this.cropBox = { x: x0 - padX, y: y0 - padY, w: x1 - x0 + 2 * padX, h: y1 - y0 + 2 * padY };
    if (!(this.cropBox.w > 1) || !(this.cropBox.h > 1)) {
      this.cropBox = { x: 0, y: 0, w: img.width, h: img.height };
    }
    return this.cropBox;
  };

  PDM.prototype.stillLayout = function () {
    var cv = this.stillCv;
    var rect = cv.getBoundingClientRect();
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var cw = Math.round(rect.width * dpr),
      ch = Math.round(rect.height * dpr);
    if (cv.width !== cw || cv.height !== ch) {
      cv.width = cw;
      cv.height = ch;
    }
    var box = this.markBox();
    var s = Math.min(3, Math.min(cw / box.w, ch / box.h));
    return {
      dpr: dpr,
      cw: cw,
      ch: ch,
      s: s,
      ox: (cw - box.w * s) / 2 - box.x * s,
      oy: (ch - box.h * s) / 2 - box.y * s
    };
  };

  PDM.prototype.toView = function (p, L) {
    return { x: L.ox + (this.best.canvas.width - p.x) * L.s, y: L.oy + p.y * L.s };
  };
  PDM.prototype.toImg = function (p, L) {
    return { x: this.best.canvas.width - (p.x - L.ox) / L.s, y: (p.y - L.oy) / L.s };
  };

  PDM.prototype.drawStill = function () {
    if (!this.best || !this.stillCv) return;
    var cv = this.stillCv;
    var rect = cv.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var ctx = cv.getContext('2d');
    var L = this.stillLayout();
    var img = this.best.canvas;
    ctx.clearRect(0, 0, L.cw, L.ch);
    ctx.save();
    ctx.translate(L.ox + img.width * L.s, L.oy);
    ctx.scale(-L.s, L.s);
    ctx.drawImage(img, 0, 0);
    ctx.restore();

    var m = this.best.marks;
    var vL = this.toView(m.cardL, L),
      vR = this.toView(m.cardR, L);
    ctx.save();
    ctx.strokeStyle = 'rgba(255,255,255,.95)';
    ctx.lineWidth = 2 * L.dpr;
    ctx.beginPath();
    ctx.moveTo(vL.x, vL.y);
    ctx.lineTo(vR.x, vR.y);
    ctx.stroke();
    ctx.restore();

    var self = this;
    var draw = function (key, color) {
      var v = self.toView(m[key], L);
      var active = self.dragKey === key;
      var seen = !!(self.inspected && self.inspected[key]);
      ctx.save();
      ctx.beginPath();
      ctx.arc(v.x, v.y, (active ? 16 : 13) * L.dpr, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(0,0,0,.32)';
      ctx.fill();
      ctx.lineWidth = 2.5 * L.dpr;
      ctx.strokeStyle = color;
      ctx.stroke();
      /* A dot the customer has already looked at gets a green collar, so the
         remaining ones are obvious at a glance. */
      if (seen) {
        ctx.beginPath();
        ctx.arc(v.x, v.y, (active ? 20 : 17) * L.dpr, 0, Math.PI * 2);
        ctx.lineWidth = 2 * L.dpr;
        ctx.strokeStyle = 'rgba(90,220,140,.95)';
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(v.x, v.y, 2.2 * L.dpr, 0, Math.PI * 2);
      ctx.fillStyle = color;
      ctx.fill();
      ctx.restore();
    };
    draw('cardL', 'rgba(255,255,255,.98)');
    draw('cardR', 'rgba(255,255,255,.98)');
    draw('pupL', 'rgba(255,60,80,.98)');
    draw('pupR', 'rgba(255,60,80,.98)');

    if (this.dragKey) this.drawLoupe(L);
    else if (this.loupe) this.loupe.hidden = true;
  };

  PDM.prototype.drawLoupe = function (L) {
    var lp = this.loupe;
    if (!lp) return;
    lp.hidden = false;
    var size = 124;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    if (lp.width !== size * dpr) {
      lp.width = size * dpr;
      lp.height = size * dpr;
    }
    var ctx = lp.getContext('2d');
    var img = this.best.canvas;
    var p = this.best.marks[this.dragKey];
    var zoom = 5;
    ctx.save();
    ctx.clearRect(0, 0, lp.width, lp.height);
    ctx.beginPath();
    ctx.arc(lp.width / 2, lp.height / 2, lp.width / 2 - 1, 0, Math.PI * 2);
    ctx.clip();
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, lp.width, lp.height);
    ctx.translate(lp.width / 2, lp.height / 2);
    ctx.scale(-zoom, zoom);
    ctx.drawImage(img, -p.x, -p.y);
    ctx.restore();
    ctx.save();
    ctx.strokeStyle = 'rgba(255,80,90,.95)';
    ctx.lineWidth = 1.5 * dpr;
    ctx.beginPath();
    ctx.moveTo(lp.width / 2 - 14 * dpr, lp.height / 2);
    ctx.lineTo(lp.width / 2 + 14 * dpr, lp.height / 2);
    ctx.moveTo(lp.width / 2, lp.height / 2 - 14 * dpr);
    ctx.lineTo(lp.width / 2, lp.height / 2 + 14 * dpr);
    ctx.stroke();
    ctx.restore();

    /* keep the magnifier in the corner furthest from the finger */
    var vp = this.toView(p, L);
    lp.setAttribute('data-h', vp.x > L.cw / 2 ? 'left' : 'right');
    lp.setAttribute('data-v', vp.y < L.ch * 0.45 ? 'bottom' : 'top');
  };

  PDM.prototype.bindEditor = function () {
    var self = this;
    var cv = this.stillCv;
    var keys = ['cardL', 'cardR', 'pupL', 'pupR'];

    var locate = function (ev) {
      var L = self.stillLayout();
      var rect = cv.getBoundingClientRect();
      return { L: L, pt: { x: (ev.clientX - rect.left) * L.dpr, y: (ev.clientY - rect.top) * L.dpr } };
    };

    cv.addEventListener('pointerdown', function (ev) {
      if (!self.best) return;
      var r = locate(ev);
      var bestK = null,
        bestD = 34 * r.L.dpr;
      keys.forEach(function (k) {
        var v = self.toView(self.best.marks[k], r.L);
        var d = Math.hypot(v.x - r.pt.x, v.y - r.pt.y);
        if (d < bestD) {
          bestD = d;
          bestK = k;
        }
      });
      if (!bestK) return;
      ev.preventDefault();
      self.dragKey = bestK;
      self.inspected[bestK] = true;
      self.updateVerifyGate();
      /* Grab by offset, never snap to the finger: a tap 30 px away from a dot
         would otherwise shove it several millimetres in one go. */
      var v = self.toView(self.best.marks[bestK], r.L);
      self.grab = { dx: v.x - r.pt.x, dy: v.y - r.pt.y };
      try {
        cv.setPointerCapture(ev.pointerId);
      } catch (e) {}
      self.drawStill();
    });

    cv.addEventListener('pointermove', function (ev) {
      if (!self.dragKey) return;
      ev.preventDefault();
      var r = locate(ev);
      var g = self.grab || { dx: 0, dy: 0 };
      self.best.marks[self.dragKey] = self.toImg({ x: r.pt.x + g.dx, y: r.pt.y + g.dy }, r.L);
      self.markEdited();
      self.drawStill();
    });

    var end = function () {
      if (!self.dragKey) return;
      self.dragKey = null;
      self.grab = null;
      self.drawStill();
    };
    cv.addEventListener('pointerup', end);
    cv.addEventListener('pointercancel', end);
    cv.addEventListener('pointerleave', end);
  };

  PDM.prototype.markEdited = function () {
    if (this.editorEdited) return;
    this.editorEdited = true;
    var note = $(this.root, '[data-pdm-verify-note]');
    if (note) {
      note.textContent = this.t.verManual;
      note.hidden = false;
    }
  };

  /* --------------------------- Result ------------------------------- */
  PDM.prototype.showResult = function () {
    var t = this.t;
    var geom = this.geom;
    var m = this.best.marks;

    /* The still is the fallback and also what we use once the customer has
       actually moved a dot — their eyes beat our sub-pixel search. */
    var cardPx = dist(m.cardL, m.cardR) || 1;
    var stillG = geom.solve(cardPx, this.best.canvas.width, this.best.canvas.height);
    var rawStill = (dist(m.pupL, m.pupR) / cardPx) * CARD_W_MM;
    var pdStill = rawStill * stillG.factor;

    var shift = this.shiftMM();
    var useStill = shift > 1.5 || this.samples.length < 6;

    var pd,
      raw,
      distMM = stillG.dist,
      zEff = stillG.zCard,
      spread = null,
      n = 1,
      pdIris = null,
      low = false;
    if (!useStill) {
      var rc = this.samples.map(function (s) {
        return s.ratioCard * CARD_W_MM * geom.solve(s.cardPx, s.fw, s.fh).factor;
      });
      var med = median(rc);
      var sd = mad(rc, med);
      var kept = rc.filter(function (v) {
        return sd === 0 || Math.abs(v - med) <= 2.5 * sd;
      });
      pd = trimmedMean(kept, 0.2);
      raw = trimmedMean(
        this.samples.map(function (s) {
          return s.ratioCard * CARD_W_MM;
        }),
        0.2
      );
      zEff = median(
        this.samples.map(function (s) {
          return geom.solve(s.cardPx, s.fw, s.fh).zCard;
        })
      );
      distMM = zEff + geom.off;
      spread = sd;
      n = kept.length;
      pdIris = trimmedMean(
        this.samples.map(function (s) {
          return s.ratioIris * IRIS_MM;
        }),
        0.2
      );
      low = sd > 1.2 || n < 10;
    } else {
      pd = pdStill;
      raw = rawStill;
    }
    var pdGeom = pd;
    pd += this.calib;

    var monoR = null,
      monoL = null;
    if (this.best.bridge) {
      var ax = m.pupR.x - m.pupL.x,
        ay = m.pupR.y - m.pupL.y;
      var len = Math.hypot(ax, ay) || 1;
      var scale = pd / len;
      var br = this.best.bridge;
      var proj = function (p) {
        return Math.abs(((p.x - br.x) * ax + (p.y - br.y) * ay) / len);
      };
      monoR = proj(m.pupL) * scale;
      monoL = proj(m.pupR) * scale;
    }

    var rounded = Math.round(pd * 2) / 2;
    $(this.root, '[data-pdm-value]').textContent = rounded.toFixed(1);
    var conf = $(this.root, '[data-pdm-confidence]');
    conf.textContent = low ? t.resLow : t.resGood;
    conf.setAttribute('data-low', low ? 'true' : 'false');

    var det = [];
    if (spread != null) det.push(fmt(t.resSpread, { v: spread.toFixed(1), n: n }));
    if (distMM > 0) det.push(fmt(t.resDist, { v: (distMM / 10).toFixed(0) }));
    if (isFinite(raw) && Math.abs(pdGeom - raw) >= 0.05) {
      det.push(fmt(t.resRaw, { v: raw.toFixed(1) }));
      det.push(
        fmt(t.resGeom, {
          v: '+' + (pdGeom - raw).toFixed(1),
          d: '+' + ((raw * geom.off) / (zEff || 1)).toFixed(1),
          c: '+' + ((raw * geom.rot) / (zEff || 1)).toFixed(1)
        })
      );
    }
    if (this.calib) det.push(fmt(t.resCalib, { v: (this.calib > 0 ? '+' : '') + this.calib.toFixed(2) }));
    if (pdIris != null) {
      det.push(fmt(t.resCross, { v: pdIris.toFixed(1) }));
      if (Math.abs(pdIris - pd) > 4.5) det.push(t.resCrossBad);
    }
    if (shift > 1.5) det.push(fmt(t.resShift, { v: shift.toFixed(1) }));
    else if (useStill) det.push(t.resManual);
    var detEl = $(this.root, '[data-pdm-detail]');
    detEl.innerHTML = '';
    det.forEach(function (line) {
      var p = document.createElement('p');
      p.textContent = line;
      detEl.appendChild(p);
    });

    var monoEl = $(this.root, '[data-pdm-mono]');
    if (monoEl) {
      if (monoR && monoL) {
        monoEl.textContent = fmt(t.resMono, { r: monoR.toFixed(1), l: monoL.toFixed(1) });
        monoEl.hidden = false;
      } else monoEl.hidden = true;
    }

    this.copyText = 'PD: ' + rounded.toFixed(1) + ' mm';
    this.go('result');
  };

  /* ---------------------------- Debug ------------------------------- */
  PDM.prototype.demoStill = function () {
    var w = 720,
      h = 960;
    var cv = document.createElement('canvas');
    cv.width = w;
    cv.height = h;
    var c = cv.getContext('2d');
    c.fillStyle = '#20242c';
    c.fillRect(0, 0, w, h);
    /* Shrink the whole face so the card covers a realistic slice of the frame;
       otherwise the debug screens imply the customer is 15 cm from the lens. */
    var S = 0.42;
    var tx = function (x) {
      return w / 2 + (x - w / 2) * S;
    };
    var ty = function (y) {
      return h / 2 + (y - h / 2) * S;
    };
    c.translate(w / 2, h / 2);
    c.scale(S, S);
    c.translate(-w / 2, -h / 2);
    c.fillStyle = '#c9a184';
    c.beginPath();
    c.ellipse(w / 2, h * 0.52, w * 0.27, h * 0.29, 0, 0, Math.PI * 2);
    c.fill();
    c.fillStyle = '#2b2b2b';
    c.beginPath();
    c.ellipse(w / 2, h * 0.26, w * 0.29, h * 0.1, 0, 0, Math.PI * 2);
    c.fill();
    var eyeY = h * 0.5,
      pd = 200;
    [-1, 1].forEach(function (s) {
      c.fillStyle = '#fff';
      c.beginPath();
      c.ellipse(w / 2 + (s * pd) / 2, eyeY, 34, 18, 0, 0, Math.PI * 2);
      c.fill();
      c.fillStyle = '#4a3520';
      c.beginPath();
      c.arc(w / 2 + (s * pd) / 2, eyeY, 15, 0, Math.PI * 2);
      c.fill();
      c.fillStyle = '#111';
      c.beginPath();
      c.arc(w / 2 + (s * pd) / 2, eyeY, 6, 0, Math.PI * 2);
      c.fill();
    });
    var cardW = (pd * CARD_W_MM) / 63,
      cardH = (cardW * 53.98) / CARD_W_MM;
    var cardY = eyeY - 0.7 * pd;
    c.fillStyle = '#e8e4dc';
    c.fillRect(w / 2 - cardW / 2, cardY - cardH / 2, cardW, cardH);
    c.fillStyle = '#8d8d8d';
    c.fillRect(w / 2 - cardW / 2 + 14, cardY + 6, cardW * 0.4, 12);
    c.setTransform(1, 0, 0, 1, 0, 0);
    return {
      canvas: cv,
      score: 1,
      bridge: { x: tx(w / 2), y: ty(eyeY) },
      marks: {
        cardL: { x: tx(w / 2 - cardW / 2), y: ty(cardY) },
        cardR: { x: tx(w / 2 + cardW / 2), y: ty(cardY) },
        pupL: { x: tx(w / 2 - pd / 2), y: ty(eyeY) },
        pupR: { x: tx(w / 2 + pd / 2), y: ty(eyeY) }
      }
    };
  };

  PDM.prototype.mountDebug = function () {
    var self = this;
    var bar = document.createElement('div');
    bar.className = 'pdm-dbg';
    var mk = function (label, fn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.addEventListener('click', fn);
      bar.appendChild(b);
      return b;
    };
    mk('1 intro', function () {
      self.stopCamera();
      self.go('intro');
    });
    mk('2 camera', function () {
      self.stopCamera();
      self.go('capture');
      self.setCoach('cReady', true);
      if (self.measureBtn) self.measureBtn.disabled = false;
      self.offerManual();
    });
    mk('3 verify', function () {
      self.stopCamera();
      self.best = self.demoStill();
      self.samples = [];
      self.showVerify();
    });
    mk('result', function () {
      self.stopCamera();
      if (!self.best) self.best = self.demoStill();
      self.editorEdited = false;
      self.samples = [];
      self.showResult();
    });
    mk('error', function () {
      self.fail('eDenied');
    });
    mk('load', function () {
      self.go('capture');
      self.showLoading('loadModel', 0.42);
    });
    this.dbgFps = document.createElement('span');
    this.dbgFps.style.cssText = 'color:#0f0;font:11px monospace;align-self:center;padding:0 6px';
    this.dbgFps.textContent = '– fps';
    bar.appendChild(this.dbgFps);
    document.body.appendChild(bar);
    this.dbgBar = bar;
  };

  /* ---------------------------- Boot -------------------------------- */
  function boot() {
    all(document, '[data-pdm-root]').forEach(function (el) {
      if (el.getAttribute('data-pdm-init')) return;
      el.setAttribute('data-pdm-init', '1');
      try {
        el.pdm = new PDM(el);
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
